import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { getChatScriptSource } from '../commons/assistente-pessoal/assistente-pessoal.config';
import { getAvaliacoesConfig } from '../commons/avaliacoes/avaliacoes.config';
import { detectaNavegador } from '../commons/detecta-navegador/detecta-navegador.config';
import { getFormacaoSociomeocionalConfig } from '../commons/formacao-socioemocional/formacao-socioemocional.config';
import { getChatHelp } from '../commons/menu/chat-help/chat-help.config';
import { getSubMenusDisciplinas } from '../commons/menu/disciplinas/disciplinas.config';
import { getItensMenuConfig } from '../commons/menu/menu.config';
import { paraMsalConfiguration } from '../commons/msal.commons';
import { getTapumeAvaliacoesConfig } from '../commons/tapume-avaliacoes/tapume-avaliacoes.config';
import { getTapumeConfig } from '../commons/tapume-erro-carregamento/tapume-erro-carregamento.config';
import { Environment } from '../types';
import {
  AJUDA_LOGIN,
  EMPREGABILIDADE,
  EXTENSOES_VALIDAS_ENVIO_ARQUIVO,
  TESTE_SOCIOCOMPORTAMENTAL,
  tapume,
} from './common';

import { getEvaChatConfig } from '../commons/chat-bot-eva-source/chat-bot-eva-source.config';
import { getElegibilidadeAlunoNovaHome } from '../commons/elegibilidade-aluno-nova-home/elegibilidade-aluno-nova-home';
import { getElegibilidadeDashboardDisicplinaConfig } from '../commons/elegibilidade-dashboard-disciplina/elegibilidade-dashboard-disciplina.config';
import { getElegibilidadeExibirNomeTutorDisciplinaConfig } from '../commons/elegibilidade-exibir-nome-tutor-disciplina/elegibilidade-exibir-nome-tutor-disciplina.config';
import { getElegibilidadeMuralAvisos } from '../commons/elegibilidade-mural-avisos/elegibilidade-mural-avisos';
import { getElegibilidadeRenovaConfig } from '../commons/elegibilidade-renova/elegibilidade-renova.config';
import { getElegibilidadeSecaoAvaliacoes } from '../commons/elegibilidade-secao-avaliacoes/elegibilidade-secao-avaliacoes.config';
import { getElegibilidadeSuporteAosEstudosConfig } from '../commons/elegibilidade-suporte-aos-estudos/elegibilidade-suporte-aos-estudos.config';
import { elegivelTapumeManutencao } from '../commons/elegibilidade-tapume-manutencao/elegibilidade-tapume-manutencao.config';
import { getElegibilidadeWidgetAvaliacaoConfig } from '../commons/elegibilidade-widget-avaliacao/elegibilidade-widget-avaliacao.config';
import { segmentacaoOcultarMenuAvaliacoesConfig } from '../commons/segmentacao-ocultar-menu-avaliacoes/segmentacao-ocultar-menu-avaliacoes.config';
import { isCarrosselElegivel } from './common/carroussel-elegivel.common';

const localHost = 'localhost';
const buildSettings = (): UserManagerSettings => {
  const authDev = localStorage.getItem('authDev') === 'true';
  return {
    authority: authDev
      ? 'https://login.microsoftonline.com/da49a844-e2e3-40af-86a6-c3819d704f49/v2.0/'
      : 'http://localhost:7777',
    client_id: authDev ? 'e7f499e0-ed3b-4be8-bf55-336edd160698' : 'webapp-aura-local',
    redirect_uri: `http://${localHost}:3003/`,
    post_logout_redirect_uri: `http://${localHost}:3003/`,
    userStore: new WebStorageStateStore({ store: localStorage }),
    response_type: 'code',
    loadUserInfo: false,
    scope: 'e7f499e0-ed3b-4be8-bf55-336edd160698/.default',
  };
};

const local = (): Environment => {
  const settings: UserManagerSettings = buildSettings();
  const apiDev = localStorage.getItem('apiDev') === 'true';
  const apiUrl = localStorage.getItem('apiUrl');
  const apiV2Url = localStorage.getItem('apiV2Url');
  const urlQc = localStorage.getItem('urlQc');
  const ambiente = 'local';
  const marca = 'wyden';
  return {
    contextos: [{ host: `http://${localHost}:3003` }],
    ambiente,
    marca,
    tapume,
    idClienteEnsineme: 'A39EAE23-8E99-27B8-82FC-D5ABAF8953CD',
    API_DEDICADA: apiDev
      ? (apiUrl ?? 'https://apis.estudante.wyden.sava.dev.yduqs.com.br/rest')
      : `http://${localHost}:5001`,
    API: apiDev ? (apiUrl ?? 'https://sava-wyden.estaciodev.net/apis') : `http://${localHost}:5001`,
    API_V2: apiDev
      ? (apiV2Url ?? 'https://estudante-sava-wyden.estaciodev.net/aura-frontend')
      : `http://${localHost}:5001`,
    URL_QC: apiDev ? (urlQc ?? 'https://lms.stg.labs.qcx.com.br') : 'http://localhost:5001',
    URL_REDIRECT_ENSINEME: 'https://stecine.azureedge.net/repositorio/redirect/_redirect.html',
    URL_REDIRECT_REDEFINIR_SENHA: 'https://account.activedirectory.windowsazure.com/ChangePassword.aspx',
    URL_ESQUECEU_SENHA: 'https://passwordreset.microsoftonline.com/',
    URL_EDUCADOR: `http://${localHost}:3013`,
    URL_FAQ: '/aura-repo/estacio/faq-estudante.pdf',
    URL_MANUAL: '/aura-repo/estacio/manual-estudante.pdf',
    URL_BASE_CALENDARIO_ACADEMICO: '/aura-repo/calendario-academico/',
    CHAT_HELP: getChatHelp('wyden'),
    EVENT_LOGIN_ENDPOINT: '/v2/eventos-login/alunos',
    EXTENSOES_VALIDAS_ENVIO_ARQUIVO,
    userManagerSettings: settings,
    msalConfiguration: paraMsalConfiguration({ settings }),
    GTM_ID: 'GTM-56HT2PR',
    TAMANHO_PAGINA_RESPOSTA_TRABALHOS: 1,
    EMPREGABILIDADE,
    AJUDA_LOGIN,
    ITENS_MENU: getItensMenuConfig({ ambiente, marca }),
    ITENS_AVALIACOES: getAvaliacoesConfig({ ambiente, marca }),
    ID_INSTITUICAO_LINKEDIN: '1020467',
    TESTE_SOCIOCOMPORTAMENTAL,
    URL_SCRIPT_CHAT_ASSISTENTE_PESSOAL: getChatScriptSource(ambiente),
    URL_ACESSO_SIRIUS_EXERCICIOS: 'https://wyden-dev.saladeavaliacoes.com.br',
    URL_ACESSO_SIRIUS_SIMULADOS: 'https://wyden-dev.saladeavaliacoes.com.br',
    URL_FICHA_CATALOGRAFICA: `https://ltechnology.com.br/gleison/`,
    SUBMENUS_DISCIPLINAS: getSubMenusDisciplinas(),
    FORMACAO_SOCIOEMOCIONAL: getFormacaoSociomeocionalConfig(),
    TAPUME_AVALIACOES: getTapumeAvaliacoesConfig(),
    TAPUME_CONFIG: getTapumeConfig({ marca }),
    NAVEGADOR_CONFIG: detectaNavegador(),
    ELEGIVEL_CARROSSEL_SUBMARCAS: isCarrosselElegivel(marca),
    ELEGIBILIDADE_DASHBOARD_DISCIPLINA: getElegibilidadeDashboardDisicplinaConfig({ ambiente }),
    ELEGIBILIDADE_EXIBIR_NOME_TUTOR_DISCIPLINA: getElegibilidadeExibirNomeTutorDisciplinaConfig(),
    URL_ADOBE_LAUNCH_SCRIPT:
      'https://assets.adobedtm.com/0b3049c26621/a6dfba573ee8/launch-a6935f17b378-development.min.js',
    ELEGIBILIDADE_WIDGET_AVALIACAO: getElegibilidadeWidgetAvaliacaoConfig({ ambiente }),
    ELEGIBILIDADE_SUPORTE_AOS_ESTUDOS: getElegibilidadeSuporteAosEstudosConfig({ ambiente }),
    ELEGIVEL_TAPUME_MANUTENCAO: elegivelTapumeManutencao({ marca }),
    SEGMENTACAO_OCULTAR_MENU_AVALIACOES: segmentacaoOcultarMenuAvaliacoesConfig,
    ELEGIBILIDADE_SECAO_AVALIACOES: getElegibilidadeSecaoAvaliacoes,
    SOURCE_CHAT_BOT_EVA: getEvaChatConfig({ ambiente, marca }),
    ELEGIBILIDADE_ALUNO_NOVA_HOME: getElegibilidadeAlunoNovaHome({ ambiente }),
    ELEGIBILIDADE_MURAL_AVISOS: getElegibilidadeMuralAvisos({ ambiente }),
    URL_RENOVA: `https://renova-${marca}.estaciodev.net`,
    ELEGIBILIDADE_RENOVA: getElegibilidadeRenovaConfig({ ambiente }),
    URL_ENADE: 'https://entenda.wyden.com.br/enade',
  };
};

export default local;
